/**
 * Opens the cart drawer when the storefront is loaded with ?cart_drawer=1 (e.g. after redirect from /cart).
 * Supports native theme cart-drawer-component and header [data-b2b-cart-open] (VIP / B2B Storefront cart).
 */
(function initCartDrawerDeepLink() {
  const PARAM = 'cart_drawer';

  function consumeParam() {
    const url = new URL(window.location.href);
    const value = url.searchParams.get(PARAM);
    if (value !== '1') return false;
    url.searchParams.delete(PARAM);
    const search = url.searchParams.toString();
    const path = `${url.pathname}${search ? `?${search}` : ''}${url.hash}`;
    window.history.replaceState({}, '', path);
    return true;
  }

  function tryOpenDrawer() {
    const native = document.querySelector('cart-drawer-component');
    if (native && typeof native.open === 'function') {
      native.open();
      return true;
    }
    const b2b = document.querySelector('[data-b2b-cart-open]');
    if (b2b) {
      b2b.click();
      return true;
    }
    return false;
  }

  function run() {
    if (!consumeParam()) return;
    if (tryOpenDrawer()) return;
    let n = 0;
    const id = window.setInterval(() => {
      n += 1;
      if (tryOpenDrawer() || n > 60) window.clearInterval(id);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
